import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardContent, Grid, Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import _ from 'lodash';

import { useTranslation } from 'react-i18next';
import { SimpleMenu, MenuWithId } from 'components';
import { useEvents, useFields, useOrganizations, useProperties } from 'hooks';
import { DashboardHelpers } from 'utils';

const GeneralInput = ({ done }) => {
  const { t } = useTranslation();
  const { properties, orgProperties, selectedProperty } = useProperties();
  const { selectedOrganizationId } = useOrganizations();
  const { selectedFieldId, fields } = useFields();
  const { setPlan, farmerPlan } = useEvents();

  const parentProp = DashboardHelpers.getParentsOfLayer(
    'field',
    farmerPlan?.layer_id,
    undefined,
    fields,
    properties
  )?.property;
  const [chosenProperty, setProperty] = useState(selectedProperty ? selectedProperty : parentProp ? parentProp : {});
  const filteredFields = DashboardHelpers.filteredFields(chosenProperty?.id, selectedOrganizationId, fields);
  const propList = orgProperties && orgProperties.length > 0 ? orgProperties : properties;

  const field = _.find(filteredFields, { id: farmerPlan?.layer_id ? farmerPlan.layer_id : selectedFieldId });
  const types = Object.values(DashboardHelpers.PlanTypes);

  useEffect(() => {
    if (selectedFieldId && !farmerPlan?.layer_id) {
      setPlan({ ...farmerPlan, layer_id: selectedFieldId });
    }
  }, [selectedFieldId]);

  return (
    <div>
      <Typography variant="h6">{t('general_information')}</Typography>
      <CardContent>
        <Grid container item>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" gutterBottom component="div">
              {t('property')}
            </Typography>
            <MenuWithId
              placeholder="Property"
              menuItems={!propList || propList.length === 0 ? [{ id: 0, name: t('none_selected') }] : propList}
              selectedItem={chosenProperty?.name}
              selectItem={(item) => {
                setProperty(item);
              }}
              inputProps={{
                maxLength: 24,
              }}
              size="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6} paddingLeft={2}>
            <Typography variant="subtitle2" gutterBottom component="div">
              {t('field')}
            </Typography>
            <MenuWithId
              placeholder="Field"
              menuItems={!filteredFields ? [{ id: 0, name: t('none_selected') }] : filteredFields}
              selectedItem={field?.name}
              selectItem={(item) => {
                setProperty(_.find(properties, { id: item.property_id }));
                setPlan({ layer_id: item.id });
              }}
              inputProps={{
                maxLength: 24,
              }}
              disabled={filteredFields?.length === 0}
              size="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6} paddingRight={2}>
            <Typography variant="subtitle2" gutterBottom component="div">
              {t('event_type')}
            </Typography>
            <SimpleMenu
              placeholder={t('type')}
              menuItems={types}
              selectedItem={farmerPlan?.data?.plan_type}
              selectItem={(item) => {
                setPlan({ type: 'plan', data: { plan_type: item } });
                done(true);
              }}
              size="normal"
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} padding={2} />
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
              label={t('event_date')}
              name={'date'}
              placeholder={t('event_date')}
              value={farmerPlan?.time}
              onChange={(event) => {
                setPlan({ time: event });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Grid>
      </CardContent>
    </div>
  );
};

GeneralInput.propTypes = {
  done: PropTypes.func,
};

export default GeneralInput;
